export default __webpack_public_path__ + "static/twist-4357b1e5760f7591c925ecfb4748a6c7.png";